import CustomerCareSearch from '../search/search.module';
import RecentCustomersComponent from './recent.customers.component';
export default angular.module('invision.customercare.recentCustomers', [CustomerCareSearch]).component('recentCustomers', RecentCustomersComponent).name;